
import React from 'react';

interface LegalOverlayProps {
  title: string;
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  closeLabel: string;
}

const LegalOverlay: React.FC<LegalOverlayProps> = ({ title, isOpen, onClose, children, closeLabel }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[250] bg-black flex flex-col animate-in fade-in duration-300">
      <header className="h-20 border-b border-white/10 flex items-center justify-between px-8 bg-black/50 backdrop-blur-md sticky top-0 z-10">
        <h2 className="text-lg font-bold tracking-tight uppercase tracking-[0.2em]">{title}</h2>
        <button 
          onClick={onClose}
          className="p-2 hover:bg-white/10 rounded-full transition-colors group"
        >
          <svg className="w-6 h-6 text-gray-400 group-hover:text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </header>
      
      <div className="flex-1 overflow-y-auto p-8 md:p-16 max-w-4xl mx-auto w-full">
        <div className="prose prose-invert max-w-none space-y-8 text-gray-400 leading-relaxed">
          {children}
        </div>
        <div className="mt-20 pt-8 border-t border-white/5 text-center">
          <button 
            onClick={onClose}
            className="px-12 py-4 bg-sky-600 text-white font-bold rounded-xl hover:bg-sky-500 transition-all shadow-lg shadow-sky-600/20"
          >
            {closeLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LegalOverlay;
